var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NationalSystem',{attrs:{"title":"AAA/Bowel","filter":r => r.notebook === 'AAA-Bowel',"scan-results":_vm.scanResults}},[_vm._v(" AAA and Bowel and pulled by NIIAS in a combined SQL job, so one of the scheduled tasks within NIIAS may have failed as we received no trigger (so far) to pull this data on this day. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }